import styled from "styled-components";
import theme from "../../../Styles/theme";


export const Container = styled.div`

    display: flex;
    align-items: center;
    flex-direction: column;

`;


export const Title = styled.h1`
   font-size: max(1.2vw, 10px);
    color: ${theme.colors.dark};
    text-align:center;
`;


export const Lista = styled.ul`
margin-top: 1vh;
margin-left: 2vw;
margin-right:2vw;


`;

export const Item = styled.li`

font-size: max(1.2vw, 10px);
    color: ${theme.colors.dark};
    display: flex;
    align-items: center;

`;


export const Span = styled.span`
margin-top: 1vh;
margin-left: 2vw;
margin-right:2vw;
font-size: max(1.2vw, 10px);
    color: ${theme.colors.dark};
    display: flex;
   

`;


export const Button = styled.button`
  
  background-color: ${theme.colors.darkGrey};
  font-size: max(1vw, 10px);
  font-weight: bold;
  color: ${theme.colors.dark};
  padding: 1vh 2vw;
  border-radius: 0.25rem;
  margin: auto;
  margin-top: 1vh;
  &:hover {
    opacity: 0.7;
  }
`;



export const HelperButtons = styled.div`

  width:100%;
  display: flex;
  align-items: center;
  justify-content:center;
  

`;